import { RiReactjsLine } from "react-icons/ri";
import { FaNodeJs } from "react-icons/fa";
import { SiMongodb, SiTailwindcss } from "react-icons/si";

import Reveal from "./Reveal";
import SectionTitle from "./SectionTitle";
import CIcon from "./Icons/CIcon";
import CssIcon from "./Icons/CssIcon";
import Html5Icon from "./Icons/Html5Icon";
import JavaIcon from "./Icons/JavaIcon";
import CsharpIcon from "./Icons/CsharpIcon";
import NextJsIcon from "./Icons/NextJsIcon";
import TSIcon from "./Icons/TSIcon";
import PythonIcon from "./Icons/PythonIcon";
import CppIcon from "./Icons/CppIcon";

import GeminiIcon from "./Icons/GeminiIcon";
import SupabaseIcon from "./Icons/SupabaseIcon";
import GithubIcon from "./Icons/GithubIcon";
import OpenAIIcon from "./Icons/OpenAIIcon";
import DockerIcon from "./Icons/DockerIcon";
import RedisIcon from "./Icons/RedisIcon";
import SublimeIcon from "./Icons/SublimeIcon";
import VsCodeIcon from "./Icons/VsCodeIcon";
import JenkinsIcon from "./Icons/JenkinsIcon";

export default function Skills() {
  const line1 = [
    { Icon: RiReactjsLine, color: "text-cyan-400", name: "React" },
    { Icon: FaNodeJs, color: "text-yellow-500", name: "Node.js" },
    { Icon: SiMongodb, color: "text-green-500", name: "MongoDB" },
    { Icon: Html5Icon, color: "text-orange-500", name: "HTML5" },
    { Icon: CssIcon, color: "", name: "CSS" },
    { Icon: TSIcon, color: "text-cyan-600", name: "TypeScript" },
    { Icon: NextJsIcon, color: "text-white", name: "Next.js" },
    { Icon: GeminiIcon, color: "", name: "Gemini" },
    { Icon: SupabaseIcon, color: "text-white", name: "Supabase" },
    { Icon: SiTailwindcss, color: "text-cyan-400", name: "Tailwind CSS" },
    { Icon: GithubIcon, color: "text-white", name: "GitHub" },
  ];

  const line2 = [
    { Icon: PythonIcon, color: "", name: "Python" },
    { Icon: CIcon, color: "text-[#065798]", name: "C" },
    { Icon: CppIcon, color: "", name: "C++" },
    { Icon: CsharpIcon, color: "text-white", name: "C#" },
    { Icon: JavaIcon, color: "text-red-500", name: "Java" },
    { Icon: OpenAIIcon, color: "text-white", name: "OpenAI" },
    { Icon: DockerIcon, color: "", name: "Docker" },
    { Icon: RedisIcon, color: "", name: "Redis" },
    { Icon: SublimeIcon, color: "", name: "Sublime Text" },
    { Icon: VsCodeIcon, color: "", name: "VS Code" },
    { Icon: JenkinsIcon, color: "", name: "Jenkins" },
  ];

  const SkillCard = ({ Icon, color, name }) => (
    <div
      role="img"
      aria-label={name}
      title={name}
      className="marquee-item aspect-square h-14 sm:h-24 rounded-xl border-biolum-green/20 p-2 sm:p-4 border glass-card transition-colors duration-300 flex items-center justify-center"
    >
      {Icon && <Icon aria-hidden="true" className={`w-7 h-7 sm:w-12 sm:h-12 shrink-0 ${color}`} />}
    </div>
  );

  return (
    <section id="skills">
      <div className="pb-14 container flex flex-col items-center px-4 py-10 mx-auto">
        <SectionTitle>Skills</SectionTitle>

        {/* No overflow-hidden here: it clips the rows' bottoms while the
            scroll-reveal still has them translated down. Each
            .marquee-container clips its own horizontal overflow. */}
        <div className="flex flex-col w-full gap-4 sm:gap-8">
          {/* First Line - Moving Left */}
          <Reveal delay={0.1} className="marquee-container">
            <div className="animate-marquee-left">
              {[...line1, ...line1].map((skill, index) => (
                <SkillCard key={`l1-${index}`} {...skill} />
              ))}
            </div>
          </Reveal>

          {/* Second Line - Moving Right */}
          <Reveal delay={0.2} className="marquee-container">
            <div className="animate-marquee-right">
              {[...line2, ...line2, ...line2].map((skill, index) => (
                <SkillCard key={`l2-${index}`} {...skill} />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
